import * as React from 'react'

export const useVisibleOnce = (
	element: React.RefObject<HTMLDivElement | null>,
	rootMargin?: string,
) => {
	const [isVisible, setState] = React.useState(false)

	React.useEffect(() => {
		if (isVisible) return // already latched — no observer needed

		const el = element.current

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) setState(true)
			},
			{ rootMargin },
		)

		el && observer.observe(el)

		return () => {
			el && observer.unobserve(el)
		}
	}, [element, rootMargin, isVisible])

	return isVisible
}
